<template>
  <div class="home-index">
    <div class="bk-img"></div>
    <div class="header">
      <Header activeMenuIndex="3" @platform="updatePlatform" :disablePltBtn="false"></Header>
    </div>
    <div class="nodata" v-if="data == null || data.length == 0">
      <img :src="require('@/assets/img/nodata_market.png')" class="img" />
    </div>
    <div class="top_box" v-loading="loading" v-if="data != null && data.length > 0">
      <div class="banner">
        <el-carousel
            :interval="5000"
            height="600px"
            indicator-position="outside"
            arrow="always"
            :autoplay="true"
        >
          <el-carousel-item
              v-for="(v, index) in data.slice(0, 5)"
              :key="'bannerItem_' + index"
          >
            <div class="banner-item">
              <!-- The big NFT image -->
              <div class="img-containerBig">
                <img :src="v.url" alt="" class="background-img" />
              </div>

              <!-- Blurred overlay for text -->
              <div class="banner_detail">
                <h3>{{ v.title }}</h3>
                <span v-if="v.owner_name">By: {{ v.owner_name }}</span>
                <span>
                  <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
                  <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>

                  {{ v.price }}
                </span>
              </div>

              <!-- CTA button to go to detail page -->
              <div class="to_detail_btn" @click="toDetail(v.id)">
                <span>{{ $t('lang.detail') }}</span>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="trending">
        <div class="left">
          <el-table
              :data="trending_data.slice(0, 3)"
              style="width: 100%; cursor: pointer;"
              size="small"
              :row-class-name="tableRowClassName"
              @row-click="handleRowClick">
            <el-table-column
                prop="rank"
                label=""
                width="100">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="right" popper-class="trending-pic" width="400">
                  <img class="nft_preview" :src="scope.row.url" alt="" style="width: 100%; height: 100%" />
                  <div slot="reference">
                    <el-image class="nft_small_preview" :src="scope.row.url" lazy fit="cover" style="width: 50px; height: 50px"></el-image>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('lang.collection')"
                width="240">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>
            <el-table-column
                prop="amount"
                :label="$t('lang.BoundValue')"
                width="120">
              <template slot-scope="scope">
                <div class="eth_price_box">
                  <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
                  <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>

                  <span>{{ scope.row.amount }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="price"
                :label="$t('lang.price')"
                width="120">
              <template slot-scope="scope">
                <div class="eth_price_box">
                  <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
                  <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>

                  <span>{{ scope.row.price }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="right">
          <el-table
              :data="trending_data.slice(3, 6)"
              style="width: 100%; cursor: pointer;"
              size="small"
              :row-class-name="tableRowClassName"
              @row-click="handleRowClick">
            <el-table-column
                prop="rank"
                label=""
                width="100">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="right" popper-class="trending-pic" width="400">
                  <img class="nft_preview" :src="scope.row.url" alt="" style="width: 100%; height: 100%" />
                  <div slot="reference">
                    <el-image class="nft_small_preview" :src="scope.row.url" lazy fit="cover" style="width: 50px; height: 50px"></el-image>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('lang.collection')"
                width="280">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>
            <el-table-column
                prop="amount"
                :label="$t('lang.BoundValue')"
                width="100">
              <template slot-scope="scope">
                <div class="eth_price_box">
                  <img class="eth_icon" src="@/assets/img/icon.png" alt="" />
                  <span>{{ scope.row.amount }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="price"
                :label="$t('lang.price')"
                width="100">
              <template slot-scope="scope">
                <div class="eth_price_box">
                  <img class="eth_icon" src="@/assets/img/icon.png" alt="" />
                  <span>{{ scope.row.price }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="home-1" v-if="data.length > 0">

      <div class="home-n">
        {{ resultsInit(results) }} <span>{{ $t("lang.results") }}</span>
      </div>
      <div class="home-t">
        <span>{{ $t("lang.SortedBy") }}:</span>
        <div class="home-t-b">
          <el-select  placeholder="Select"  v-model="sort"  @change="selectChanged"  >
            <el-option :label='$t("lang.price")+":"+$t("lang.LowToHigh")' :value="1"></el-option>
            <el-option :label='$t("lang.price")+":"+$t("lang.HighToLow")' :value="2"></el-option>
            <el-option :label='$t("lang.BoundValue")+":"+$t("lang.LowToHigh")' :value="3"></el-option>
            <el-option :label='$t("lang.BoundValue")+":"+$t("lang.HighToLow")' :value="4"></el-option>
            <el-option :label='$t("lang.Recently")' :value="5"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div  class="home-box-3"  v-loading="loading" v-if="data != null && data.length > 0" >
      <ul class="card">
        <li v-for="(v, index) in data" :key="'item_' + index">
          <div class="img-container" @click="toDetail(v.id)">
            <el-image :src="v.url" lazy fit="contain"></el-image>
          </div>
          <h4>
            <span>{{ v.title }}</span>
            <span class="gray">{{$t("lang.BoundValue")}}</span>
          </h4>
          <p class="row">
            <span class="owner">{{  v.owner_name }}</span>
            <span >
                                <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
                  <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>


              {{ v.amount }}</span  >
          </p>
          <div class="hr"></div>
          <!-- 价格 -->
          <div class="sell-price">
            <!--            <span>{{$t("lang.sellPrice")}}</span>-->
            <p>
              <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>
              <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 20px;max-height: 20px;width: auto;height: auto;"/>

              <span>{{ v.price }}</span>
            </p>
            <p>
              <span @click="handleClick(v)" v-if=" v.isSame">{{$t("lang.cancel")}}</span>
              <span @click="handleClick(v)" v-else>{{$t("lang.Buy")}}</span>
            </p>
          </div>
          <!-- 收藏 -->
          <!-- <div class="Collect">
            <p>
              <span @click="handleClick(v)" v-if=" v.isSame">{{$t("lang.cancel")}}</span>
              <span @click="handleClick(v)" v-else>{{$t("lang.Buy")}}</span>
            </p>
            <img   @click="addCollect(v)"   v-if="v.is_collect" src="./../../assets/img/heart-fill.svg"   alt=""  />
            <img  @click="addCollect(v)"   v-else   src="./../../assets/img/heart.svg" alt=""  />
          </div> -->
        </li>
      </ul>
    </div>
    <cancel-dialog  ref="cancelDialog" @rest ="rest" @fail="openFail" @offWeberr="offWeberr" ></cancel-dialog>
    <purchaseDialog ref="purchaseDialog"  @rest ="rest"  @fail="openFail" @offWeberr="offWeberr" @reload="reload"></purchaseDialog>
    <connectMetamask ref="showMetamask"></connectMetamask>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "../../components/footer.vue";
import request from "../../services/request";
import {BASE_V_API} from "@/config.js"
import ad from "../../utils/web3Helper.js";
import purchaseDialog from "./../modules/purchaseDialog.vue";
import cancelDialog from "@/views/modules/cancelDialog";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "home",
  data() {
    return {
      chain: "",
      loading: false,
      platform: {},
      data: [],
      trending_data: [],
      results: "",
      base: "",
      select: "",
      sort: 2,
    };
  },
  computed: {
    ...mapState(["address"]),
  },
  created() {
    this.loadData();
  },
  methods: {
    handleRowClick(row, column, event) {
      this.toDetail(row.id);
    },
    tableRowClassName({ row, rowIndex }) {
      return 'row-class'
    },
    moment,
    rest() {
      this.loadData();
    },
    updatePlatform() {
      this.platform = JSON.parse(sessionStorage.getItem("selectedPlatform"));
      this.loadData();
    },
    handleClick(item) {
      let token = localStorage.getItem("Token");
      // if (this.address == "") {
      //   this.$refs.showMetamask.show = true;
      // } else
      if (!token) {
        sessionStorage.setItem("iSsignature", false);
        this.getSign();
        this.$router.push({name: 'login'});
        // this.$router.push({name:'login',query:{redirect:window.vm.$router.currentRoute.fullPath}});
      } else {
        if (item.isSame) {
          //isSame 是自己的就取消出售
          // this.$refs.cancelDialog.TradeId = item.trade_id;
          this.$refs.cancelDialog.openDialog(item);
        } else {
          //不是自己的就购买
          // this.$refs.purchaseDialog.TradeId = item.trade_id;
          // this.$refs.purchaseDialog.title = item.title;
          // this.$refs.purchaseDialog.price = item.price;
          // this.$refs.purchaseDialog.path = item.url;
          // this.$refs.purchaseDialog.isVideo = item.isVideo;
          this.$refs.purchaseDialog.openDialog(item);
        }
      }
    },
    resultsInit(number) {
      let nf = new Intl.NumberFormat("en-US");
      return nf.format(number);
    },
    selectChanged(value) {
      this.sort = value;
      this.loadData();
    },
    toDetail(tokenID) {
      this.$router.push({name: "nftDetail", query: {tokenID: tokenID}});
    },
    addCollect: function (item) {
      let token = localStorage.getItem("Token");
      // if (this.address == "") {
      //   this.$refs.showMetamask.show = true;
      // } else
      if (!token) {
        sessionStorage.setItem("iSsignature", false);
        this.getSign();
        this.$router.push({name: 'login'});
        // this.$router.push({name:'login',query:{redirect:window.vm.$router.currentRoute.fullPath}});
      } else {
        var para = {
          // address: this.address,
          token_id: item.id,
        };
        var that = this;
        if (item.is_collect == true) {
          request.delMyCollect(para).then((response) => {
            if (response.code == 200) {
              item.is_collect = !item.is_collect;
              that.$message.success(response.message);
              that.loadData();
            }else {
              this.$message.error(response.message);
            }
          });
        } else {
          request.addMyCollect(para).then((response) => {
            if (response.code == 200) {
              item.is_collect = !item.is_collect;
              that.$message.success(response.message);
              that.loadData();
            }else {
              that.$message.error(response.message);
            }
          });
        }
      }
    },
    loadData() {
      this.loading = true;
      this.base = BASE_V_API;
      let userInfo = JSON.parse(sessionStorage.getItem("userinfo"));
      // console.log("userinfo", userInfo.id);
      const params = {
        key: '',
        page: 1,
        page_size: 100,
        typa: 1,
        sort: this.sort,
      };
      request.getMarket(params).then((response) => {
        if (response.code == 200) {
          this.data = response.data;
          this.loading = false;
          this.data.forEach((item, index) => {
            // this.data[index].price = ad.fromWei(this.data[index].price);
            // this.data[index].amount = ad.fromWei(this.data[index].amount);
            // if (item.owner.toLowerCase() == this.address) {
            if (String(item.out_user_id) == String(userInfo.id)) {
              item.isSame = true;
            } else {
              item.isSame = false;
            }
            // let arr = item.Path.split("/");
            // let fileName = arr[arr.length - 1];
            // let fileSplit = fileName.split(".");
            // let suffixType = fileSplit[fileSplit.length - 1];
            // if (suffixType == "mp4") {
            //   item.isVideo = true;
            // } else {
            //   item.isVideo = false;
            // }
          });
          this.results = this.data.length;

        } else {
          this.loading = false;
          this.$message.error(response.message);
        }
      });
    },
    openFail(data) {
      this.weberr = false;
      console.log("data", data);
      this.$refs.failDialog.title = data.title;
      this.$refs.failDialog.descriptionText = data.desc;
      this.$refs.failDialog.openDialog();
    },
    reload(data) {
      // if (data == true) {
      //   this.userVoted = data;
      //   console.log("userVoted: " + this.userVoted);
      // }
      location.reload();
    },
    offWeberr() {
      location.reload();
    },
  },
  components: {
    Header,
    Footer,
    purchaseDialog,
    cancelDialog,
  },
};
</script>

<style lang="less" scoped>

.bk-img {
  background-image: url("../../assets/img/home/bg-image-1_1bg-image-1.avif");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 120px;
  padding-bottom: 350px;
  width: 100vw;
  height: 600px;
  position: absolute;
  top: -40px;
  left: 0;
  z-index: -100;
}
.bk-img::after {
  content: "";
  position: absolute;
  top: 300px;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
}


.home-index{
  top: 30px;
}

.top_box {

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .banner {
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    background: transparent;

    .el-carousel {
      .el-carousel__arrow {
        /* arrow styling if you want a modern look */
        opacity: 0.7;
        &:hover {
          opacity: 1;
        }
      }

      .el-carousel__indicators--outside {
        bottom: 10px;
      }
    }

    .banner-item {
      position: relative;
      width: 100%;
      height: 100%;

      /* Transition scale on hover */
      &:hover {
        .background-img {
          transform: scale(1.03);
        }
        .to_detail_btn {
          background-color: #fff;
          span {
            background: linear-gradient(90deg, #f26aff, #7d6fff);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }

      .img-containerBig {
        position: absolute;
        inset: 0;
        overflow: hidden;
        border-radius: 12px;
        transition: all 0.3s ease;

        .background-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
      }

      /* Glassmorphism style for text detail */
      .banner_detail {
        position: absolute;
        bottom: 20px;
        left: 20px;
        padding: 15px 20px;
        border-radius: 10px;
        backdrop-filter: blur(8px);
        background-color: rgba(255, 255, 255, 0.35);
        color: #333;
        z-index: 2;

        h3 {
          font-size: 24px;
          margin-bottom: 8px;
          font-weight: 600;
        }

        span {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: 600;
          margin-right: 10px;
          img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
        }
      }

      .to_detail_btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
        color: #222;
        padding: 10px 20px;
        border-radius: 10px;
        cursor: pointer;
        font-weight: 500;
        backdrop-filter: blur(8px);
        background-color: rgba(255, 255, 255, 0.35);
        transition: all 0.3s ease;
        z-index: 2;

        span {
          font-size: 18px;
        }

        &:hover {
          background-color: #fff;
        }
      }
    }
  }

  .trending {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 50px;
    margin-bottom: 20px;

    .right{
      width: 50%;

    }
    .left{
      width: 50%;
    }
  }
}

.home-index {
  min-height: 100%;
  position: relative;

  .home-1 {
    display: flex;
    width: 1200px;
    margin: auto;
    justify-content: space-between;
    margin-top: 28px;

    .home-n {
      padding: 9px 0;
      font-size: 20px;
      color: #12022f;
      font-weight: 700;

      span {
        font-size: 16px;
        font-weight: 400;
      }
    }

    .home-t {
      display: flex;
      justify-content: flex-end;

      // width: 1200px;
      // margin: auto;
      // margin-top: 28px;
      span {
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        padding: 9px 22px;
      }
    }
  }

  .home-box-3 {
    display: flex;
    //justify-content: space-between;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 328px);

    .card {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 15px 0;
      width: 100%;

      li {
        width: 24%;
        border-radius: 5%;
        overflow: hidden;
        margin-right: 1.25%;
        margin-bottom: 15px;
        cursor: pointer;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 2px 0 rgba(0, 0, 0, 0.1);
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        .img-container {
          height: 288px;
          background: #F8F8FF;
          overflow: hidden;

          .el-image {
            height: 100%;
            width: 100%;
            border-radius: 2px;
            transition: all 0.2s ease;

            &:hover {
              transform: scale(1.1);
            }
          }

          // img {
          //   object-fit: cover;
          //   height: 100%;
          //   width: 100%;
          //   border-radius: 2px;
          //   transition: all 0.2s ease;
          // }
        }

        h4 {
          justify-self: center;
          width: 90%;
          font-size: 15px;
          display: flex;
          justify-content: space-between;
          line-height: 28px;

          & > span:last-child {
            font-size: 13px;
            font-weight: normal;
          }
        }

        .gray {
          color: #666;
        }

        p {
          display: flex;
          justify-self: center;
          width: 90%;
          justify-content: space-between;
          line-height: 24px;

          & > span {
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 14px;
          }

          .owner {
            color: #666;
            font-weight: 500;
          }
        }

        img {
          width: 20px;
        }

        .hr {
          margin: 0px 0;
          height: 1px;
          width: 100%;
          background: #ebebeb;
        }

        .sell-price {
          display: flex;
          font-size: 14px;
          align-items: center;
          padding: 2px 0;
          margin-bottom: 0px;
          justify-content: space-between;

          &:hover {
            background: linear-gradient(90deg, #f26aff, #7d6fff);
            img {
              border-radius: 10px;
              backdrop-filter: blur(10px);
            }
            span {
              color: #ffffff;
            }
          }

          span {
            color: #333333;
          }

          p {
            display: flex;
            align-items: center;

            img {
              width: 20px;
              margin: 0 5px;
            }

            span {
              font-size: 18px;
              color: rgba(138, 43, 226, 1);
            }
          }
        }

        .Collect {
          display: flex;
          align-items: center;
          justify-content: space-between;
          transform: translateY(23px);
          transition: all 0.2s ease;
          color: #2d4dbd;

          span {
            &:hover {
              color: #30407c;
            }
          }

          img {
            width: 25px;
            filter: opacity(0.7);

            &:hover {
              filter: opacity(1);
            }
          }
        }

        &:hover {
          transform: translateY(-3px);
          box-shadow: 2px 8px 16px 2px rgba(0, 0, 0, 0.3), 1px 12px 4px 1px rgba(0, 0, 0, 0.2);

          .Collect {
            transform: translateY(0px);
          }
        }
      }

      li:nth-child(4n + 4) {
        margin-right: 0;
      }
    }
  }
}

.nodata {
  min-height: calc(100vh - 235px);

  .img {
    width: 208px;
    height: 239px;
    display: block;
    margin: 1.5% auto 0;
  }
}
</style>
<style scoped>

.eth_price_box{
  display: flex;
  align-items: center;
  justify-items: center;
  span{
    font-size: 16px;
    font-weight: 600;
  }
}
img.eth_icon {
  width: 24px; /* Set your desired width */
  height: 24px; /* Set your desired height */
}
img.nft_preview{
  border-radius: 10px;
}

img.nft_small_preview{
  border-radius: 10px;
  cursor: pointer;
}
.el-table .el-table__row {
  border: none;
  box-shadow: none;
}
.el-table .el-table__row:hover {
  background-color: transparent;
}
::v-deep .row-class{
  border-radius: 10px;

  h3{
    font-size: 17px;
    font-weight: 600;
  }
  span{
    font-size: 15px;
    font-weight: 600;
  }
}
</style>
